import React from 'react';
import styled from 'styled-components';
import { IconFaceVeryUnhappy, DetailedIconWrench } from '@zillow/constellation';

const applyStyleToSvg = (Icon: React.ComponentType) => {
  return styled((props: React.SVGAttributes<SVGElement>) => {
    return <Icon {...props} />;
  })`
    display: block;
    height: 8rem;
    width: 8rem;
    margin: 0 auto;
    color: #ff8c8f;
  `;
};

const StyledBrokenIcon = applyStyleToSvg(IconFaceVeryUnhappy);
const StyledWrenchIcon = applyStyleToSvg(DetailedIconWrench);

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Contents = styled.main`
  padding: 4.5rem 1.25rem;
`;

const MainMessage = styled.h1`
  text-align: center;
  margin: 2.5rem 0 0;
  color: #2a2a33;
  font-size: 22px;
  font-weight: 400;
`;

const SubMessage = styled.h2`
  text-align: center;
  margin: 1.5rem 0 0;
  color: #54545a;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`;

export enum ErrorIcon {
  Broken = 'broken',
  Wrench = 'wrench',
}

type Props = {
  mainMessage?: string | React.ReactNode;
  subMessage?: string | React.ReactNode;
  errorIcon?: ErrorIcon;
};

function ErrorMessage(props: Props) {
  const {
    mainMessage = 'Uh oh! Looks like something went wrong.',
    subMessage = 'Try to refresh the page or please try again later',
    errorIcon = ErrorIcon.Broken,
  } = props;

  return (
    <Container>
      <Contents>
        {errorIcon === ErrorIcon.Wrench ? (
          <StyledWrenchIcon />
        ) : (
          <StyledBrokenIcon />
        )}
        <MainMessage>{mainMessage}</MainMessage>
        <SubMessage>{subMessage}</SubMessage>
      </Contents>
    </Container>
  );
}

export default ErrorMessage;
